(() => {
  function formatMoney(cents, currency) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents); } catch (e) {}
    }
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
    return await res.json();
  }

  async function updateFreeShippingBanners() {
    const banners = document.querySelectorAll('.free-shipping-banner');
    if (!banners.length) return;

    let cart;
    try { cart = await getCart(); } catch (e) { return; }

    banners.forEach(el => {
      const threshold = parseInt(el.dataset.threshold || '0', 10);
      const currency = el.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      const subtotal = cart.total_price || 0;
      const remaining = Math.max(0, threshold - subtotal);
      const progress = Math.min(100, (subtotal / threshold) * 100 || 0);

      if (remaining > 0) {
        el.innerHTML = `Osta vielä ${formatMoney(remaining, currency)} saadaksesi ilmaisen toimituksen ✨
          <div class="fs-bar"><span class="fs-fill" style="width:${progress}%"></span></div>`;
      } else {
        el.innerHTML = `Ilmainen toimitus aktivoitu! 🎉
          <div class="fs-bar"><span class="fs-fill" style="width:100%"></span></div>`;
      }
    });
  }

  const schedule = () => setTimeout(updateFreeShippingBanners, 60);

  // Alustava päivitys
  document.addEventListener('DOMContentLoaded', updateFreeShippingBanners);

  // Päivitys, kun osioita ladataan uudelleen (Dawn/Sections)
  document.addEventListener('shopify:section:load', updateFreeShippingBanners);

  // Yleisimmät tapahtumat (määrän muutos, lisäys, drawerin avautuminen)
  document.addEventListener('change', (e) => {
    if (e.target.closest('cart-items') || e.target.name === 'updates[]') schedule();
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('product-form') || e.target.name === 'add') schedule();
  });

  // Huolehdi cart drawerista (DOM muuttuu)
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });

  // Varmuuskoukku — jos teema dispatchettaa omia tapahtumia
  ['cart:refresh','cart-drawer:open','cart:updated'].forEach(evt =>
    document.addEventListener(evt, updateFreeShippingBanners)
  );
})();

document.addEventListener('cart-drawer:open', () => {
  if (window.updateFreeShippingBanners) window.updateFreeShippingBanners();
});

